
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Ug8x", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $67c012166b43ab0c$export$6503ec6e8aabbaf; }, function (v) { return $67c012166b43ab0c$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $67c012166b43ab0c$export$f7ad0328861e2f03; }, function (v) { return $67c012166b43ab0c$export$f7ad0328861e2f03 = v; });
var $67c012166b43ab0c$export$6503ec6e8aabbaf;
var $67c012166b43ab0c$export$f7ad0328861e2f03;
"use strict";
var $67c012166b43ab0c$var$mapping = new Map();
function $67c012166b43ab0c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$67c012166b43ab0c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $67c012166b43ab0c$var$resolve(id) {
    var resolved = $67c012166b43ab0c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$67c012166b43ab0c$export$6503ec6e8aabbaf = $67c012166b43ab0c$var$register;
$67c012166b43ab0c$export$f7ad0328861e2f03 = $67c012166b43ab0c$var$resolve;

});

parcelRegister("92HC5", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $695621aa74b73e2a$export$bdfd709ae4826697; }, function (v) { return $695621aa74b73e2a$export$bdfd709ae4826697 = v; });
var $695621aa74b73e2a$export$bdfd709ae4826697;
var $695621aa74b73e2a$export$c9e73fbda7da57b6;
var $695621aa74b73e2a$export$5a759dc7a1cfb72a;
"use strict";
var $695621aa74b73e2a$var$bundleURL = {};
function $695621aa74b73e2a$var$getBundleURLCached(id) {
    var value = $695621aa74b73e2a$var$bundleURL[id];
    if (!value) {
        value = $695621aa74b73e2a$var$getBundleURL();
        $695621aa74b73e2a$var$bundleURL[id] = value;
    }
    return value;
}
function $695621aa74b73e2a$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $695621aa74b73e2a$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $695621aa74b73e2a$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $695621aa74b73e2a$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$695621aa74b73e2a$export$bdfd709ae4826697 = $695621aa74b73e2a$var$getBundleURLCached;
$695621aa74b73e2a$export$c9e73fbda7da57b6 = $695621aa74b73e2a$var$getBaseURL;
$695621aa74b73e2a$export$5a759dc7a1cfb72a = $695621aa74b73e2a$var$getOrigin;

});

parcelRegister("84jYr", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("aTnpf")).then(()=>parcelRequire("5pFC1"));

});
parcelRegister("jmEuB", function(module, exports) {
"use strict";

var $epnDT = parcelRequire("epnDT");
module.exports = $epnDT(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("epnDT", function(module, exports) {
"use strict";
var $a7d5bd68ac71a390$var$cachedBundles = {};
var $a7d5bd68ac71a390$var$cachedPreloads = {};
var $a7d5bd68ac71a390$var$cachedPrefetches = {};
function $a7d5bd68ac71a390$var$getCache(type) {
    switch(type){
        case "preload":
            return $a7d5bd68ac71a390$var$cachedPreloads;
        case "prefetch":
            return $a7d5bd68ac71a390$var$cachedPrefetches;
        default:
            return $a7d5bd68ac71a390$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a7d5bd68ac71a390$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("CvXKl", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8qlyY")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("bTshp"))
]).then(()=>parcelRequire("9s8yO"));

});

parcelRegister("8mT5i", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8qlyY")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("16iPs"))
]).then(()=>parcelRequire("e8y07"));

});

parcelRegister("5vLZb", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8qlyY")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("eTzkw"))
]).then(()=>parcelRequire("d7nkV"));

});

parcelRegister("aVgMy", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("dXNlz")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("b5rzm"))
]).then(()=>parcelRequire("kXac5"));

});

parcelRegister("bk63w", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8qlyY")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("5MI2K"))
]).then(()=>parcelRequire("6wxEl"));

});

parcelRegister("8ltg2", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8qlyY")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("N637Y"))
]).then(()=>parcelRequire("aQbHi"));

});

parcelRegister("9u2AP", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8qlyY")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("kp3fT"))
]).then(()=>parcelRequire("hBGZx"));

});

parcelRegister("eKyru", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("23sYp")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("adhYS"))
]).then(()=>parcelRequire("iskSB"));

});

parcelRegister("iww9l", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("23sYp")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("a3tBI"))
]).then(()=>parcelRequire("1mAy2"));

});

parcelRegister("1uRNv", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("23sYp")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("22F8I"))
]).then(()=>parcelRequire("d5hG9"));

});

parcelRegister("jRHE4", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("23sYp")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4By39"))
]).then(()=>parcelRequire("d0jk8"));

});

parcelRegister("lwLTI", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("iy0Xz")).then(()=>parcelRequire("4BYzq"));

});

parcelRegister("k8Elh", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("dXNlz")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8qlyY")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("aTnpf")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("eT6lh"))
]).then(()=>parcelRequire("1qPDV"));

});

var $216724e2982f21fa$exports = {};


(parcelRequire("8Ug8x")).register((parcelRequire("92HC5")).getBundleURL("jz30T"), JSON.parse('["jz30T","as-modern.js","aTnpf","ccm19.module.d048b285.js","bTshp","flyout.module.277f6ef2.js","8qlyY","flyout.module.01f31ed6.js","16iPs","header.module.7b42bcd1.js","eTzkw","magnificPopup.module.014b0575.js","b5rzm","modal.module.006343ad.js","dXNlz","modal.module.8629965f.js","5MI2K","panel.module.577fbc1d.js","N637Y","stickyButton.module.26f0a5d3.js","kp3fT","readMoreMarker.module.d4960244.js","adhYS","swiper1.module.89e9ae0b.js","23sYp","swiper1.module.191369d5.js","a3tBI","swiper2.module.3317a05b.js","22F8I","swiper3.module.0e1b55b7.js","4By39","swiperTeam.module.dc86152c.js","iy0Xz","treatmentSearch.module.768baa90.js","eT6lh","asVideo.module.a3e058ff.js"]'));

// =============================================================
// IMPORTS
// =============================================================

(parcelRequire("84jYr")).then((module)=>{
    module.init();
});

// =============================================================
// MODULES
// - Lazy loaded modules which are imported when needed
// =============================================================
if (document.querySelector(".flyout-menu")) (parcelRequire("CvXKl")).then((module)=>{
    module.init();
});

if (document.querySelector(".header")) (parcelRequire("8mT5i")).then((module)=>{
    module.init();
});

if (document.querySelector(".lightbox")) (parcelRequire("5vLZb")).then((module)=>{
    module.init();
});

if (document.querySelector(".modal")) (parcelRequire("aVgMy")).then((module)=>{
    module.init();
});

if (document.querySelector(".panel")) (parcelRequire("bk63w")).then((module)=>{
    module.init();
});

if (document.getElementById("stickyButton")) (parcelRequire("8ltg2")).then((module)=>{
    module.init();
});

if (document.querySelector(".read-more-marker")) (parcelRequire("9u2AP")).then((module)=>{
    module.init();
});

if (document.querySelector(".swiper-container.swiper-container--1")) (parcelRequire("eKyru")).then((module)=>{
    module.init();
});

if (document.querySelector(".swiper-container.swiper-container--2")) (parcelRequire("iww9l")).then((module)=>{
    module.init();
});

if (document.querySelector(".swiper-container.swiper-container--3")) (parcelRequire("1uRNv")).then((module)=>{
    module.init();
});

if (document.querySelector(".swiper-container.swiper-team")) (parcelRequire("jRHE4")).then((module)=>{
    module.init();
});

if (document.querySelector(".ctype-ce_treatment_search")) (parcelRequire("lwLTI")).then((module)=>{
    module.init();
});

if (document.querySelector(".js-player")) (parcelRequire("k8Elh")).then((module)=>{
    module.init();
});
 // =============================================================
 // OTHER
 // =============================================================
 // const updateHeaderHeight = () => {
 //   let headerHeight = document.querySelector("header").offsetHeight;
 //   document.querySelector("main").style.marginTop = headerHeight + "px";
 // };
 // updateHeaderHeight();
 // =============================================================
 // WHEN COMPLETE
 // functions which are called when the page is fully loaded
 // =============================================================
 // let attempts = 0;
 // const whenComplete = () => {
 //   if (++attempts > 30) return;
 //   if (document.readyState === "complete") {
 //     window.addEventListener("resize", function (e) {
 //       updateHeaderHeight();
 //     });
 //   } else {
 //     setTimeout(() => whenComplete(), 400);
 //   }
 // };
 // whenComplete();
 // =============================================================
 // STYLES COMPLETE
 // Removes styles_essential when general styles are loaded
 // =============================================================
 // let styleAttempts = 0;
 // const stylesComplete = () => {
 //   if (++styleAttempts > 30) return;
 //   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
 //     document.querySelector("#sess").remove();
 //   } else {
 //     setTimeout(() => stylesComplete(), 300);
 //   }
 // };
 // stylesComplete();


//# sourceMappingURL=as-modern.js.map
